export const RouteAccess = {
  Administrator: 'AU',
  All:['AU'],
};


export const TokenStoreKey = 'auth-token';
